<template>
  <div>
    <br>
    <h5 class="pageTitle">Cours d'ornithologie offerts par le COQ</h5>
    <table id="professeur">
      <tr>
        <td style="padding-bottom:50px"><img :src="require('../../../public/images/hibou_livre.png')" alt=""/></td>
        <!-- Le padding sert à éloigner les onglets -->
        <td>
          <table>
            <tr>
              <td><h1 class="titre">Le Club offre deux catégories de cours portant sur l'ornithologie:</h1></td>
            </tr>
            <tr>
              <td>
                <table>
                  <tr>
                    <td><img :src="require('../../../public/images/fleche_boulet.png')" alt=""/></td>
                    <td><h1>des cours <span style="color:#b1661b;">d'initiation;</span></h1></td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table>
                  <tr>
                    <td><img :src="require('../../../public/images/fleche_boulet.png')" alt=""/></td>
                    <td><h1>des cours <span style="color:#b1661b;">spécialisés.</span></h1></td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>  <!-- Fin de 'professeur' -->

    <div id="intro">
      <h2 class="pageSubtitle2">Cours d'initiation - Apprenez à mieux identifier les oiseaux</h2>
      <p>Les cours <span style="color:#b1661b; font-weight: bold;">d'initiation à l'ornithologie, Niveau 1 et Niveau 2,</span> sont offerts
        respectivement à l'automne et au printemps par le Club des ornithologues de Québec.</p>
      <p>Ces cours s'adressent surtout aux débutants, mais aussi à tous ceux et celles qui ressentent le besoin de se ressourcer.</p>
      <p>Conçus pour s'adapter à la période de l'année à laquelle ils sont donnés, ces cours vous permettront d'acquérir tous les outils
        nécessaires
        pour mieux apprécier la pratique de ce loisir qu'est l'ornithologie.</p>
      <p>Dans le cadre de chacun des cours, des sorties sont prévues sur le terrain afin de perfectionner les techniques apprises!</p>
      <p>Vous y apprendrez des trucs simples et efficaces dans une ambiance dynamique et très animée!</p>
      <p>
        Ces cours ont été donnés par Michel Loiselle pendant&nbsp;20 ans. Une équipe formée de Josée Normandeau, Jacques Anctil et Norbert
        Lacroix a pris la relève au printemps 2018.</p>
      <br/>
    </div>

    <!-- Onglets -->
    <div id="barreNavigation">
      <div id="liste">
        <ul>
          <li><a href="#" id="ongletActif">Cours d'initiation</a></li>
          <li>
            <router-link :to="{ name: 'CoursSpecialisesPage' }">Cours spécialisés</router-link>
          </li>
        </ul>
      </div>
    </div><!-- Fin des onglets -->

    <div v-for="_class in cours" :key="_class._id">
      <class :_class="_class"/>
      <div class="separateur"></div>
    </div>
    <div v-if="cours.length === 0">
      <br/>
      <p>Il n'y a pas de cours d'initiation pour le moment.</p>
    </div>

  </div>
</template>

<script>
  import Class from '../../components/Cours/Cours';
  import CoursMixin from '@/pages/Cours/Cours.mixin';

  export default {
    name: 'CoursInit',
    components: { Class },
    mixins: [ CoursMixin ],
    data() {
      return {
        classType: 'cours_initiation'
      };
    }
  };
</script>

<style scoped>
p {
  margin-left: 0 !important;
}

li {
  margin-bottom: 0 !important;
}

p a {
  font-size: 12px !important;
}
</style>
